webpackJsonp([1],{

/***/ 810:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(965),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4eb42427",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 825:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(832), __esModule: true };

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "tableModal",
  props: ["src", "sourceMetaData"],

  data: function data() {
    return {
      isSourceMetaModalActive: false,
      sourceInfo: {},
      firstLink: [],
      linkFirst: ''
    };
  },

  methods: {
    switchIt: function switchIt() {
      this.isSourceMetaModalActive = false;
      this.$emit('switchOff');
    },
    viewSourceMetadata: function viewSourceMetadata(theSource) {

      for (var i = 0; i < this.sourceMetaData.length; i++) {
        if (theSource == this.sourceMetaData[i][0]) {
          this.sourceInfo.name = this.sourceMetaData[i][0];
          this.sourceInfo.fullName = this.sourceMetaData[i][1];
          this.sourceInfo.description = this.sourceMetaData[i][2];
          this.sourceInfo.available = this.sourceMetaData[i][3];
          this.sourceInfo.nextAvailable = this.sourceMetaData[i][4];
          this.sourceInfo.links = this.sourceMetaData[i][5].replace(/\s+/g, '').split(',');
          // this.sourceInfo.links = this.sourceMetaData[i][5];
          this.sourceInfo.method = this.sourceMetaData[i][6];
          this.sourceInfo.subNatVal = this.sourceMetaData[i][7];
          // console.log(this.sourceMetaData[i][5]);

          var check1 = this.sourceMetaData[i][5];
          var check2 = check1.split(', ');

          // console.log(check2);

          // var check3 = check2.split(' ');

          this.firstLink = check2;
          this.linkFirst = this.firstLink;
          // console.log(this.firstLink);

        }
      }

      this.isSourceMetaModalActive = !this.isSourceMetaModalActive;
    }
  },

  mounted: function mounted() {
    //console.log(this.src);
    this.viewSourceMetadata(this.src);
    //console.log(this.src);
  }
});

/***/ }),

/***/ 832:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(834);
module.exports = __webpack_require__(8).Object.assign;


/***/ }),

/***/ 833:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(65);
var gOPS = __webpack_require__(138);
var pIE = __webpack_require__(90);
var toObject = __webpack_require__(92);
var IObject = __webpack_require__(421);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(43)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ 834:
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(17);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(833) });


/***/ }),

/***/ 837:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(15)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(839),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 839:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "active": _vm.isSourceMetaModalActive,
      "has-modal-card": "",
      "onCancel": this.switchIt
    },
    on: {
      "update:active": function($event) {
        _vm.isSourceMetaModalActive = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_c('b', [_vm._v("DATA SOURCE: ")]), _vm._v(" " + _vm._s(this.sourceInfo.name))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body"
  }, [_c('div', {
    staticClass: "tabs is-boxed is-right"
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("FULL NAME")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.fullName))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.description))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading col-xs-6"
  }, [_vm._v("YEARS WITH AVAILABLE DATA")]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading col-xs-6"
  }, [_vm._v("NEXT AVAILABLE DATA")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v(_vm._s(this.sourceInfo.available))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_vm._v(_vm._s(this.sourceInfo.nextAvailable))])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("LINKS")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.firstLink), function(firstLink) {
    return _c('span', {
      key: firstLink
    }, [_c('a', {
      attrs: {
        "href": firstLink.trim().split(' ')[1],
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(firstLink.trim().split(' ')[0])), _c('br')])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("METHODOLOGY")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(_vm._s(this.sourceInfo.method))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-info"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_vm._v("SUB-NATIONAL DATA AVAILABLE")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('span', [_vm._v(" " + _vm._s(this.sourceInfo.subNatVal))])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-danger pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.switchIt
    }
  }, [_vm._v("CLOSE")])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mt_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_mt_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_mt_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    TableModal: __WEBPACK_IMPORTED_MODULE_1__components_mt_vue___default.a
  },
  data: function data() {
    return {
      datafull: [],
      datasingle: '',
      isSourceMetaModalActive: false,
      wrapperClick: true,
      aboutContent: true,
      isShowing: false,
      indicators: [],
      showIndicatorBool: [],
      apiUrl: "https://car-dashboard-others.firebaseio.com/masterSheet.json",
      // dataSourceUrl: "https://car-dashboard-others.firebaseio.com/data-source-meta-data.json",
      dataSourceUrl: "https://car-dashboard-others.firebaseio.com/data-source-meta-data-test.json",
      lsMetaData: JSON.parse(this.$ls.get('source_meta_dataset')),
      indicatorMetaData: JSON.parse(this.$ls.get('meta_data_dataset')),
      lsData: JSON.parse(this.$ls.get('car_other_dataset')),
      // dataSources: ['NHMIS', 'MICS', 'NNHS', 'NDHS', 'NMIS', 'NARHS', 'IHME', 'World Bank', 'WHO-GHO', 'WUENIC'],
      dataSources: ['NHMIS', 'NDHS', 'NHSPSS', 'MICS', 'NNHS', 'NHA', 'NMIS', 'NARHS', 'PCCS', 'WHO-GHO', 'World Bank', 'IHME', 'WUENIC', 'UNAIDS', 'KDGHS'],
      dataSourceForTable: ['S/N', 'Sources/Indicators', 'NHMIS', 'NDHS', 'NHSPSS', 'MICS', 'NNHS', 'NHA', 'NMIS', 'NARHS', 'PCCS', 'WHO - GHO', 'World Bank', 'IHME', 'WUENIC', 'UNAIDS', 'KDGHS'],
      metaData: [],
      availableSourceData: [],
      isDataForSourceAvailable: {},
      showTable: true,
      showModalBoolean: false,
      showModalBoolean2: false,
      showAvailableSourceTable: true,
      indicatorNames: [],
      indicator: '',
      source: '',
      isDataLoadedFirstTime: false,
      yearsForSource: [],
      isLoading: false,
      modalContent: [],
      linksData: [],
      firstLink: [],
      linkFirst: ''
    };
  },

  methods: {
    clearModal: function clearModal() {
      this.isSourceMetaModalActive = false;
    },
    viewSourceMetadata: function viewSourceMetadata(theSource) {
      this.datasingle = theSource;
      this.datafull = this.lsMetaData;
      //console.log(this.datafull);
      this.isSourceMetaModalActive = true;
    },
    wrapperClicked: function wrapperClicked() {
      this.wrapperClick = !this.wrapperClick;
    },

    /**
     * 
         processText(inputText) {
      var output = [];
      var json = inputText.split(',');
      json.forEach(function (item) {
          output.push(item.replace(/\'/g).split(' ').filter(Boolean));
      });
      return output;
    },
    showContents (){
    this.aboutContent = !this.aboutContent;
    },
    */
    navigateToCentralAnalytics: function navigateToCentralAnalytics() {
      var _this = this;

      this.isLoading = true;
      setTimeout(function () {
        _this.$router.push('central_analytics');
      }, 1000);
    },

    /**
    changeShowIndicatorBool(val){
    this.showIndicatorBool[val] = !this.showIndicatorBool[val];
    // console.log(this.showIndicatorBool[val])
    },
    handleScroll(){
    // if (document.body.scrollTop > 500 || document.documentElement.scrollTop > 500) {
    //   document.getElementById("scrollToTopButton").style.display = "block";
    //   document.getElementById("scrollToButtomButton").style.display = "none";
    // }
    // else {
    //   document.getElementById("scrollToTopButton").style.display = "none";
    //   document.getElementById("scrollToButtomButton").style.display = "block";
    // }
    },
    scrollPage(section_id){
    this.$scrollTo(section_id, 1000, {})
    },  */
    checkForAvailableData: function checkForAvailableData() {
      var _this2 = this;

      var dataObj = {};
      this.availableSourceData.map(function (obj, i) {
        dataObj[obj.indicator] = [];
        _this2.dataSources.map(function (source, index) {
          if (obj.dataSources.indexOf(source) > -1) {
            dataObj[obj.indicator].push(true);
          } else {
            dataObj[obj.indicator].push(false);
          }
        });
      });
      this.isDataForSourceAvailable = dataObj;
      // console.log(this.isDataForSourceAvaliable);
    },
    showModal: function showModal(message) {
      this.indicator = message[0];
      this.source = this.dataSources[message[1]];
      this.yearsForSource = this.getAvailableYearBySource(message[0], this.dataSources[message[1]], this.lsData).split(',');
      this.showModalBoolean = true;
    },
    computeDataSourceMetaData: function computeDataSourceMetaData(data) {
      var tempData = [];
      var counter = 1;
      data.slice(1).map(function (elem, index) {
        var dataObj = {
          number: counter,
          source: elem[0],
          fullName: elem[1],
          description: elem[2],
          link: elem[5],
          available: elem[3],
          next: elem[4],
          method: elem[6],
          subNationalData: elem[7],
          classification: elem[8],
          show: false

        };
        tempData.push(dataObj);
        counter++;
      });
      this.metaData = tempData;
    },
    showContent: function showContent(data) {
      this.modalContent['source'] = data.source;
      this.modalContent['fullName'] = data.fullName;
      this.modalContent['description'] = data.description;
      this.modalContent['available'] = data.available;
      this.modalContent['next'] = data.next;
      this.modalContent['method'] = data.method;
      this.modalContent['subNatVal'] = data.subNationalData;
      this.modalContent['link'] = data.link;
      var check1 = data.link;

      // var hdsda = "http://mics.unicef.org/surveys, 1995 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/Nigeria-1995-MICS_English.pdf, 1999 https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-99-Final-Report-Oct-2001-Nov-2002.pdf&form-id=4&field-id=69&hash=aad5fab711b3b635218d6477bc396a7607f432f4915a91378a09bed9318d2eec, 2007 https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-2007.pdf&form-id=4&field-id=69&hash=30fde9467a0badf677357516988b1112c3a8dbe5b8ecf1add3c0c87fa10f6d58, 2011 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/MICS-2011.pdf, 2016 https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/MICS-2016-2017.pdf";

      // console.log(check1);

      // this.firstLink= [
      //   {
      //     year: 2102,
      //     link: "http://mics.unicef.org/surveys"
      //   },
      //   {
      //     year: 1995,
      //     link: "https://mapping.fmohconnect.gov.ng/wp-content/uploads/2019/05/Nigeria-1995-MICS_English.pdf"
      //   },
      //   {

      //     link: "https://mapping.fmohconnect.gov.ng/index.php?gf-download=2019%2F05%2FMICS-99-Final-Report-Oct-2001-Nov-2002.pdf&form-id=4&field-id=69&hash=aad5fab711b3b635218d6477bc396a7607f432f4915a91378a09bed9318d2eec"
      //   },
      // ]

      // var check2 = this.processText(hdsda);
      var check2 = check1.split(',');
      // console.log(check2);

      // var check3 = check2.split(' ');
      this.firstLink = check2;
      this.linkFirst = this.firstLink[0];

      // console.log(this.firstLink);
      //  var countedCheck2 = check2.length;

      //   for(var i = 0; i <= countedCheck2; i++){
      //     if(isNaN(check2)){
      //       this.firstLink.link[i].push(check2);
      //       // console.log("Numbers" + check2[i])
      //     }
      //     else{
      //       console.log("Strings" + check2[i])
      //     }
      //   }
      //  this.firstLink = check2
      // console.log(test[0]);
      this.showModalBoolean2 = true;
    },
    filterSourceSurvey: function filterSourceSurvey(data) {
      return data.filter(function (data) {
        return data.classification == 'Survey';
      });
    },
    filterSourceRoutine: function filterSourceRoutine(data) {
      return data.filter(function (data) {
        return data.classification == 'Routine';
      });
    },
    filterSourceEstimate: function filterSourceEstimate(data) {
      return data.filter(function (data) {

        return data.classification == 'Estimate';
      });
    },
    computeAvailableSourceData: function computeAvailableSourceData(data) {
      var _this3 = this;

      var counter = 1;
      this.availableSourceData = [];
      var indicatorNamesArray = data[0];
      // console.log(data)
      this.indicatorNames.map(function (indicator) {
        var dataSourceArray = [];
        _this3.dataSources.map(function (dataSource) {
          var indicatorSource = indicator.name + ' -> ' + dataSource;
          var indexOfIndicatorSource = indicatorNamesArray.indexOf(indicatorSource);
          if (indexOfIndicatorSource > 0) {
            if (dataSourceArray.indexOf(dataSource) < 0) {
              dataSourceArray.push(dataSource);
            }
          }
        });
        var obj = {
          number: counter,
          indicator: indicator.name,
          programArea: indicator.programArea,
          dataSources: dataSourceArray,
          availableYears: _this3.getAvailableYearBySource(indicator.name, dataSourceArray, data)
        };
        _this3.availableSourceData.push(obj);
        counter++;
      });
      // console.log(this.availableSourceData)
    },
    getAvailableYearBySource: function getAvailableYearBySource(indicator, sources, data) {
      var yearArray = [];
      if (Array.isArray(sources)) {
        sources.map(function (source) {
          var tempArray = [];
          var indicatorSource = indicator + ' -> ' + source;
          var indexOfIndicatorSource = data[0].indexOf(indicatorSource);
          data.slice(1).map(function (elem) {
            if (elem[indexOfIndicatorSource] !== "") {
              if (tempArray.indexOf(elem[0]) < 0) {
                tempArray.push(elem[0]);
              }
            }
          });
          yearArray.push({ name: source, years: tempArray });
        });
      } else {
        var tempArray = [];
        var indicatorSource = indicator + ' -> ' + sources;
        var indexOfIndicatorSource = data[0].indexOf(indicatorSource);
        data.slice(1).map(function (elem) {
          if (elem[indexOfIndicatorSource] !== "") {
            if (tempArray.indexOf(elem[0]) < 0) {
              tempArray.push(elem[0]);
            }
          }
        });
        yearArray = tempArray.toString();
      }

      return yearArray;
    },
    getCarData: function getCarData() {
      return this.axios.get(this.apiUrl);
    },
    getMetaData: function getMetaData() {
      return this.axios.get(this.dataSourceUrl);
    }
  },
  created: function created() {
    /**
     * 
        this.axios.all([ this.getCarData(),this.getMetaData()])
      .then(this.axios.spread( (carData,metaData) => {
        // All requests are now complete
        // car data here ...
        this.lsData = carData.data;
        this.$ls.set('car_other_dataset', JSON.stringify(this.lsData));
        // console.log(this.lsData)
        this.isDataLoadedFirstTime = true;
        //meta data here ...
        this.lsMetaData = metaData.data;
        // console.log(metaData.data)
        this.$ls.set('source_meta_dataset',JSON.stringify(this.lsMetaData));
        this.isDataLoadedFirstTime = true;
      })
      ).catch(error => {
        if(!this.lsData){
          this.lsData = JSON.parse(this.$ls.get('car_other_dataset'));
        }
        if(!this.lsMetaData){
          this.lsMetaData = JSON.parse(this.$ls.get('source_meta_dataset'));
        }
        this.isDataLoadedFirstTime = true;
      })
    */
    var indicatorArray = {};
    var indicator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.CAR.programAreasToIndicators);

    for (var i in indicator) {
      indicatorArray[i] = {};
      indicatorArray[i].show = false;
      indicatorArray[i].children = indicator[i];
    }

    this.indicators = indicatorArray;
    // window.addEventListener('scroll', this.handleScroll);
  },

  /** 
  updated() {
    // let header = document.getElementsByClassName('stickyHeader');
    // let thead = document.getElementById('tableHead');
    // let icon = document.getElementById('back_to_car')
    // let iconTop = icon.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    // let cpanelNavTop = thead.getBoundingClientRect().top - document.body.getBoundingClientRect().top;
    // window.addEventListener('scroll', function() {
    //   if(document.documentElement.scrollTop > iconTop){
    //     icon.style.position = 'sticky';
    //     icon.style.top = '10px';
    //     icon.style.left = '10px';
    //   } else {
    //     if(document.body.getBoundingClientRect().top < 0){
              
    //     } else {
    //       icon.style.position = 'absolute';
    //       icon.style.top = '80px';
    //       icon.style.left = '100px';
    //     }
    //   }
    //   for(var i in header){
    //     if(document.documentElement.scrollTop > cpanelNavTop) {
    //       if(header[i].innerHTML){
    //         header[i].style.position = 'sticky';
    //         header[i].style.top = '0px';
    //         header[i].style.background = '#c4c4c4';
    //       }
    //       // cpanelNav.style.zindex = 0;
    //     } else {
    //       if(header[i].innerHTML){
    //         header[i].style.background = ''
    //       }
    //     }
    //   }
    // });
  },
  */
  mounted: function mounted() {
    var _this4 = this;

    this.lsMetaData = JSON.parse(this.$ls.get('source_meta_dataset'));

    // this.isLoading = true;
    // console.log(this.lsData);
    if (this.lsMetaData) {

      this.computeDataSourceMetaData(this.lsMetaData);
      this.isDataLoadedFirstTime = true;
    }

    //Dynamically populate program area array from sheet
    var indicatorsAndProgramAreas = {};
    this.$store.dispatch('indicatorLength', this.indicatorMetaData.length - 1);
    this.$store.dispatch('lastUpdated', this.indicatorMetaData[0][16]);

    this.indicatorMetaData.slice(1).map(function (meta, count) {

      var slope = [];
      var percent = "";

      if (meta[6] in indicatorsAndProgramAreas) {
        indicatorsAndProgramAreas[meta[6]].push(meta[0]);
      } else {
        indicatorsAndProgramAreas[meta[6]] = [];
        indicatorsAndProgramAreas[meta[6]].push(meta[0]);
      }
    });

    this.$store.dispatch('indicatorsAndProgramAreas', indicatorsAndProgramAreas);

    var indicatorArray = {};
    var indicator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.$store.state.CAR.programAreasToIndicators);
    for (var i in indicator) {
      indicatorArray[i] = {};
      indicatorArray[i].show = false;
      indicatorArray[i].children = indicator[i];
      indicator[i].forEach(function (elem) {
        var obj = {
          name: elem,
          programArea: i
        };
        _this4.indicatorNames.push(obj);
      });
    }
    if (this.lsData) {
      this.computeAvailableSourceData(this.lsData);
      this.isDataLoadedFirstTime = true;
    }
    this.indicators = indicatorArray;
    this.checkForAvailableData();
  },

  watch: {
    showIndicatorBool: function showIndicatorBool(val) {},
    lsMetaData: function lsMetaData(val) {
      if (val) {
        this.isDataLoadedFirstTime = true;
        this.computeDataSourceMetaData(val);
      }
    },
    lsData: function lsData(val) {
      if (val) {
        this.isDataLoadedFirstTime = true;
        this.computeAvailableSourceData(val);
      }
    }
  }
});

/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(804)(true);
// imports


// module
exports.push([module.i, "html[data-v-4eb42427]{font-family:arial}[data-v-4eb42427]::-webkit-scrollbar{width:10px;height:12px}[data-v-4eb42427]::-webkit-scrollbar-thumb{background-color:#a9a9a9}table[data-v-4eb42427]{border-collapse:none!important}.content table td[data-v-4eb42427],.content table th[data-v-4eb42427]{border:none!important;border-width:0 0 1px;padding:.5em .75em;vertical-align:top}.table-div[data-v-4eb42427]{max-width:100%;overflow-x:auto;background-color:#d3d3d3}.Table[data-v-4eb42427]{background-color:transparent;min-width:100%}.Table tbody[data-v-4eb42427],.Table thead[data-v-4eb42427]{display:block}.Table thead[data-v-4eb42427]{background-color:#fcfcfc;border-bottom:1px solid #f5f5f5;padding:10px}.Table thead th[data-v-4eb42427]{background-color:#fcfcfc;font-size:70%;font-weight:400!important;padding-right:50px;padding-bottom:50px}.Table thead>tr[data-v-4eb42427]{width:calc(100% - 10px)}.TableDefault tbody[data-v-4eb42427]{max-height:100%!important}.TableNormal tbody[data-v-4eb42427]{max-height:750px!important}.Table tbody[data-v-4eb42427]{overflow-x:hidden;font-size:70%;font-weight:400!important}.Table tr[data-v-4eb42427]{display:-webkit-box;display:-ms-flexbox;display:flex}.Table td[data-v-4eb42427],.Table th[data-v-4eb42427]{overflow:hidden;text-overflow:clip;white-space:normal;padding:3px 10px;width:100%;background-color:#fff}.Table th[data-v-4eb42427]{background-color:#d3d3d3}.Table tr:nth-child(1n)>td[data-v-4eb42427]{background-color:#fcfcfc}.Table tr:nth-child(2n)>td[data-v-4eb42427]{background-color:#f2f2f2}.Table td[data-v-4eb42427]:nth-child(2),.Table th[data-v-4eb42427]:nth-child(2){min-width:15%}.nanleContainer[data-v-4eb42427]{padding-right:15px;padding-left:15px;margin-right:auto;margin-left:auto}#loading-screen[data-v-4eb42427]{top:-158px!important}@media (min-width:768px){.nanleContainer[data-v-4eb42427]{width:750px!important}}@media (min-width:992px){.nanleContainer[data-v-4eb42427]{width:970px!important}}@media (min-width:1200px){.nanleContainer[data-v-4eb42427]{width:1170px!important}}@media screen and (max-width:700px){.TableNormal tbody[data-v-4eb42427]{max-height:450px!important}}", "", {"version":3,"sources":["/var/www/msdat-dashboard/src/components/dashboards/car/mainCar/about.vue"],"names":[],"mappings":"AACA,sBACE,iBAAkB,CACnB,AACD,qCACI,WAAY,AACZ,WAAa,CAChB,AACD,2CACI,wBAA0B,CAC7B,AACD,uBACE,8BAAgC,CACjC,AACD,sEACI,sBAAwB,AACxB,qBAAsB,AACtB,mBAAsB,AACtB,kBAAoB,CACvB,AACD,4BACE,eAAe,AACf,gBAAgB,AAEhB,wBAA2B,CAC5B,AACD,wBACE,6BAA6B,AAC7B,cAAe,CAChB,AACD,4DAEE,aAAc,CACf,AACD,8BACE,yBAA0B,AAC1B,gCAAmC,AACnC,YAAc,CACf,AACD,iCACE,yBAA0B,AAC1B,cAAe,AACf,0BAA4B,AAC5B,mBAAoB,AACpB,mBAAqB,CACtB,AACD,iCACE,uBAAwB,CACzB,AACD,qCACE,yBAA2B,CAC5B,AACD,oCACE,0BAA6B,CAC9B,AACD,8BAEE,kBAAkB,AAClB,cAAe,AACf,yBAA4B,CAC7B,AACD,2BACG,oBAAoB,AACpB,oBAAoB,AACpB,YAAa,CACf,AACD,sDAEE,gBAAgB,AAChB,mBAAmB,AACnB,mBAAoB,AACpB,iBAAiB,AACjB,WAAW,AACX,qBAAuB,CACxB,AACD,2BACE,wBAA2B,CAC5B,AACD,4CACE,wBAAyB,CAC1B,AACD,4CACE,wBAAyB,CAC1B,AACD,gFAEE,aAAc,CACf,AACD,iCACE,mBAAoB,AACpB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAkB,CACnB,AACD,iCACE,oBAAuB,CACxB,AACD,yBACA,iCACI,qBAAwB,CAC3B,CACA,AACD,yBACA,iCACI,qBAAwB,CAC3B,CACA,AACD,0BACA,iCACI,sBAAyB,CAC5B,CACA,AACD,oCACA,oCACI,0BAA6B,CAChC,CACA","file":"about.vue","sourcesContent":["\nhtml[data-v-4eb42427] {\n  font-family:arial;\n}\n[data-v-4eb42427]::-webkit-scrollbar {\n    width: 10px;\n    height: 12px;\n}\n[data-v-4eb42427]::-webkit-scrollbar-thumb {\n    background-color:darkgray;\n}\ntable[data-v-4eb42427] {\n  border-collapse:none !important;\n}\n.content table td[data-v-4eb42427], .content table th[data-v-4eb42427] {\n    border: none !important; \n    border-width: 0 0 1px;\n    padding: 0.5em 0.75em;\n    vertical-align: top;\n}\n.table-div[data-v-4eb42427] {\n  max-width:100%;\n  overflow-x:auto;\n  \n  background-color:lightgray;\n}\n.Table[data-v-4eb42427] {\n  background-color:transparent;\n  min-width:100%;\n}\n.Table thead[data-v-4eb42427],\n.Table tbody[data-v-4eb42427] {\n  display:block;\n}\n.Table thead[data-v-4eb42427] {\n  background-color: #fcfcfc;\n  border-bottom:1px solid whitesmoke;\n  padding: 10px;\n}\n.Table thead th[data-v-4eb42427] {\n  background-color: #fcfcfc;\n  font-size: 70%;\n  font-weight: 400 !important;\n  padding-right: 50px;\n  padding-bottom: 50px;\n}\n.Table thead > tr[data-v-4eb42427] {\n  width:calc(100% - 10px);\n}\n.TableDefault tbody[data-v-4eb42427]{\n  max-height:100% !important;\n}\n.TableNormal tbody[data-v-4eb42427]{\n  max-height: 750px !important;\n}\n.Table tbody[data-v-4eb42427] {\n  \n  overflow-x:hidden;\n  font-size: 70%;\n  font-weight: 400 !important;\n}\n.Table tr[data-v-4eb42427] {\n   display:-webkit-box;\n   display:-ms-flexbox;\n   display:flex;\n}\n.Table td[data-v-4eb42427], \n.Table th[data-v-4eb42427] {\n  overflow:hidden;\n  text-overflow:clip;\n  white-space:initial;\n  padding:3px 10px;\n  width:100%;\n  background-color:white;\n}\n.Table th[data-v-4eb42427] {\n  background-color:lightgray;\n}\n.Table tr:nth-child(1n) > td[data-v-4eb42427] {\n  background-color:#fcfcfc;\n}\n.Table tr:nth-child(2n) > td[data-v-4eb42427] {\n  background-color:#f2f2f2;\n}\n.Table th[data-v-4eb42427]:nth-child(2),\n.Table td[data-v-4eb42427]:nth-child(2) {\n  min-width:15%;\n}\n.nanleContainer[data-v-4eb42427] {\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n#loading-screen[data-v-4eb42427] {\n  top: -158px !important;\n}\n@media (min-width: 768px) {\n.nanleContainer[data-v-4eb42427] {\n    width: 750px !important;\n}\n}\n@media (min-width: 992px) {\n.nanleContainer[data-v-4eb42427] {\n    width: 970px !important;\n}\n}\n@media (min-width: 1200px) {\n.nanleContainer[data-v-4eb42427] {\n    width: 1170px !important;\n}\n}\n@media screen and (max-width: 700px) {\n.TableNormal tbody[data-v-4eb42427]{\n    max-height: 450px !important;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 923:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(902);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(803)("8ab19338", content, true, {});

/***/ }),

/***/ 965:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    attrs: {
      "id": "loading-screen"
    }
  }, [_c('div', {
    staticClass: "fancy-loader"
  }, [_c('span', [_vm._v("LOADING")]), _vm._v(" "), _c('svg', {
    staticClass: "lds-comets",
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "250px",
      "height": "250px",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('g', {
    attrs: {
      "transform": "rotate(162.228 50 50)"
    }
  }, [_c('animateTransform', {
    attrs: {
      "attributeName": "transform",
      "type": "rotate",
      "repeatCount": "indefinite",
      "values": "360 50 50;240 50 50;120 50 50;0 50 50",
      "keyTimes": "0;0.333;0.667;1",
      "dur": "1s",
      "keySplines": "0.7 0 0.3 1;0.7 0 0.3 1;0.7 0 0.3 1",
      "calcMode": "spline"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#41918E",
      "d": "M91,74.1C75.6,98,40.7,102.4,21.2,81c11,9.9,26.8,13.5,40.8,8.7c7.4-2.5,13.9-7.2,18.7-13.3 c1.8-2.3,3.5-7.6,6.7-8C90.5,67.9,92.7,71.5,91,74.1z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#E0E0E0",
      "d": "M50.7,5c-4,0.2-4.9,5.9-1.1,7.3c1.8,0.6,4.1,0.1,5.9,0.3c2.1,0.1,4.3,0.5,6.4,0.9c5.8,1.4,11.3,4,16,7.8 C89.8,31.1,95.2,47,92,62c4.2-13.1,1.6-27.5-6.4-38.7c-3.4-4.7-7.8-8.7-12.7-11.7C66.6,7.8,58.2,4.6,50.7,5z"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "fill": "#80CBC4",
      "d": "M30.9,13.4C12,22.7,2.1,44.2,7.6,64.8c0.8,3.2,3.8,14.9,9.3,10.5c2.4-2,1.1-4.4-0.2-6.6 c-1.7-3-3.1-6.2-4-9.5C10.6,51,11.1,41.9,14.4,34c4.7-11.5,14.1-19.7,25.8-23.8C37,11,33.9,11.9,30.9,13.4z"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-4 col-md-12"
  }, [_c('div', {
    attrs: {
      "data-intro": "<b>Not Available on Help page</b><p>To play the tour guide, click on MSDAT platform and select the tour guide</p>"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.right",
      value: ('Back to platform'),
      expression: "'Back to platform'",
      modifiers: {
        "right": true
      }
    }],
    staticClass: "back-to-car-icon",
    on: {
      "click": _vm.navigateToCentralAnalytics
    }
  }, [_c('v-icon', {
    staticClass: "back-to-car-icon-v",
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v("arrow_back")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "nanleContainer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "cnick col-md-6"
  }, [_c('aside', [_c('h1', [_vm._v("About Platform")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The essence of health data is to ensure that decision-makers have the means to make informed decisions and policies for healthcare.\n              "), _c('a', {
    staticClass: "visible-xs-block",
    on: {
      "click": function($event) {
        _vm.aboutContent = !_vm.aboutContent
      }
    }
  }, [_vm._v(_vm._s(_vm.aboutContent ? 'Show Less' : 'Show More'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.aboutContent),
      expression: "aboutContent"
    }]
  }, [_c('p', {
    staticClass: "about_content"
  }, [_vm._v("This Multi-Source Data Analytic and Triangulation resource developed by the Federal Ministry of Health (FMoH) Nigeria provides a single transparent view of key health indicators from multiple data sources. Recognizing that data quality, trends and interpretation depend on the data source and methodology, the platform offers comparisons of key metrics across three categories of data sources, namely; routine, surveys, and global estimates. ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("By transparently visualizing data and trends across multiple sources, we intend improving the debate and focus on data quality and its use, so as to reduce variations that exist between different sources over time and improve our overall understanding of key trends and progress within the health sector.")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              This resource has been developed and is being expanded in phases building on connections with existing FMOH agencies and partners. As this resource evolves, DHPRS hopes to contribute to improved performance management within the health sector. \n            ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The first phase started with exploration analysis using some selected indicators at the federal and state level. Subsequent phases will gradually increase the number of indicators available for analysis, and then widen the coverage of health data analysis to LGA and facility level as well.\n            ")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("\n              The DHPRS team welcomes feedback on this resource and invites stakeholders to upload relevant data using the submit data button on the platform.\n            ")])])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, _vm._l((_vm.indicators), function(indicator, index, i) {
    return _c('div', {
      key: i,
      staticClass: "col-xs-12 col-md-3",
      staticStyle: {
        "padding-bottom": "32px",
        "padding-top": "10px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          indicator.show = !indicator.show
        }
      }
    }, [_c('span', [_vm._v("\n          " + _vm._s(index) + "\n          "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(indicator.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (indicator.show),
        expression: "indicator.show"
      }],
      staticClass: "indicator-text"
    }, _vm._l((indicator.children), function(name, count) {
      return _c('span', {
        key: count
      }, [_vm._v("\n          " + _vm._s(name) + "\n        ")])
    }))])
  })), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAvailableSourceTable),
      expression: "showAvailableSourceTable"
    }],
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-div"
  }, [_c('table', {
    staticClass: "Table",
    class: {
      'TableDefault': true, 'TableNormal': _vm.wrapperClick
    },
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('thead', [_c('tr', _vm._l((_vm.dataSourceForTable), function(col, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(col))])
  }))]), _vm._v(" "), _c('tbody', _vm._l((_vm.availableSourceData), function(data, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(data.number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.indicator))]), _vm._v(" "), _vm._l((_vm.isDataForSourceAvailable[data.indicator]), function(icon, i) {
      return _c('td', {
        key: i
      }, [_c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (icon),
          expression: "icon"
        }, {
          name: "tooltip",
          rawName: "v-tooltip.top",
          value: ('Click to see available years'),
          expression: "'Click to see available years'",
          modifiers: {
            "top": true
          }
        }],
        staticStyle: {
          "cursor": "default",
          "height": "20px",
          "margin": "30px auto",
          "width": "50%",
          "padding-right": "60px"
        },
        on: {
          "click": function($event) {
            _vm.showModal([data.indicator, i])
          }
        }
      }, [_c('v-icon', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (icon),
          expression: "icon"
        }],
        attrs: {
          "dark": "",
          "color": "green"
        }
      }, [_vm._v("check_circle")])], 1)])
    })], 2)
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 col-md-offset-5 col-xs-offset-4",
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "80px",
      "color": "white"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007D53",
      "color": "white",
      "box-shadow": "0px 2px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007D53"
    },
    on: {
      "click": _vm.wrapperClicked
    }
  }, [_vm._v(_vm._s(_vm.wrapperClick ? 'Show More' : 'Show Less'))])])]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, _vm._l((_vm.filterSourceRoutine(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more")])])])])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {}, _vm._l((_vm.filterSourceSurvey(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more ")])])])])])
  }))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.filterSourceEstimate(_vm.metaData)), function(data, index) {
    return _c('div', {
      key: index,
      staticClass: "col-xs-12 col-md-4",
      staticStyle: {
        "padding-bottom": "32px"
      }
    }, [_c('div', {
      staticClass: "indicator-names-button",
      on: {
        "click": function($event) {
          data.show = !data.show
        }
      }
    }, [_c('span', [_vm._v("\n            " + _vm._s(data.source) + "\n            "), _c('v-icon', {
      staticStyle: {
        "color": "white",
        "float": "right"
      }
    }, [_vm._v(_vm._s(data.show ? 'fa fa-caret-up' : 'fa fa-caret-down'))])], 1)]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (data.show),
        expression: "data.show"
      }],
      staticClass: "indicator-text"
    }, [_c('span', [_c('p', [_vm._v(_vm._s(data.description) + " "), _c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.viewSourceMetadata(data.source)
        }
      }
    }, [_vm._v("Show more")])])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 col-md-offset-9 col-xs-offset-3"
  }, [_c('div', {
    attrs: {
      "id": "bottom_of_page"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/central_analytics"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background-color": "#007D53",
      "color": "white",
      "box-shadow": "0px 2px 15px rgba(0, 0, 0, 0.4)",
      "border-color": "#007D53"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back to platform ")])])], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-modal', {
    attrs: {
      "active": _vm.showModalBoolean,
      "has-modal-card": ""
    },
    on: {
      "update:active": function($event) {
        _vm.showModalBoolean = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "modal-card modal-card1"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-title-text"
  }, [_vm._v("The "), _c('b', [_vm._v(_vm._s(_vm.indicator))]), _vm._v(" indicator is available on "), _c('b', [_vm._v(_vm._s(_vm.source))]), _vm._v(" for these years:")]), _vm._v(" "), _c('span', {
    staticClass: "close-year-modal is-danger pull-right",
    on: {
      "click": function($event) {
        _vm.showModalBoolean = false
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body year-body"
  }, [_c('div', _vm._l((_vm.yearsForSource), function(year, count) {
    return _c('p', {
      key: count
    }, [_vm._v("\n                    " + _vm._s(year) + ",\n                  ")])
  }))])])])]), _vm._v(" "), (_vm.isSourceMetaModalActive) ? _c('div', [_c('table-modal', {
    attrs: {
      "src": _vm.datasingle,
      "sourceMetaData": _vm.datafull
    },
    on: {
      "switchOff": _vm.clearModal
    }
  })], 1) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('h1', {
    staticClass: "about_title",
    attrs: {
      "id": "top_of_page"
    }
  }, [_vm._v("Multi-Source Data Analytics and Triangulation Platform")]), _vm._v(" "), _c('h5', {
    staticClass: "about_subtitle"
  }, [_vm._v("This platform is developed and managed by the Department of Health, Planning and Research Statistics (DHPRS)")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "static/img/About-Dashboard-image.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('h1', [_vm._v("Indicators")]), _vm._v(" "), _c('p', {
    staticClass: "about_content"
  }, [_vm._v("The indicators available on the Multi-Source Data Analytics and Triangulation Platform have been categorized by their program areas and can be seen below. To see the indicators, click the drop down on each program area.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('h1', [_vm._v("Available Data")]), _vm._v(" "), _c('span', {
    staticClass: "about_content"
  }, [_vm._v("\n        Below is the total available data on this platform, all the indicators and their data sources with the available years\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 cnick"
  }, [_c('div', {}, [_c('h1', [_vm._v("Data sources")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8rem"
    }
  }, [_vm._v("\n          The list of Data sources available on the Platform can be found below:\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Routine")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Survey")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 cnick"
  }, [_c('h1', [_vm._v("Estimate")])])])
}]}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.2c2d21396a8cf8dd4d85.js